import React, { StrictMode } from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import App from './App'
import registerServiceWorker from './registerServiceWorker'
import store from './store/store'
import MomentUtils from 'material-ui-pickers/utils/moment-utils'
import MuiPickersUtilsProvider from 'material-ui-pickers/utils/MuiPickersUtilsProvider'
import { MuiThemeProvider } from 'material-ui'
import { initializeConfiguration, muiTheme, configuration } from "./configuration"
import { ConnectedRouter } from 'react-router-redux'
import { history } from './store/store'

import './index.css'

initializeConfiguration().then(() => {
  console.log(configuration())
  document.getElementById('html-root').classList.add(configuration().brandName)
  ReactDOM.render(
    <StrictMode>
      <Provider store={store}>
        <ConnectedRouter history={history}>
          <MuiPickersUtilsProvider utils={MomentUtils}>
            <MuiThemeProvider theme={muiTheme}>
              <App />
            </MuiThemeProvider>
          </MuiPickersUtilsProvider>
        </ConnectedRouter>
      </Provider>
    </StrictMode>,
    document.getElementById('app-site')
  )
  registerServiceWorker()
}).catch(() => {
  ReactDOM.render(<p>Fail to load initial configuration!!</p>, document.getElementById('app-site'))
})


// WEBPACK FOOTER //
// ./src/index.js